import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { SearchIcon, BuildingIcon } from "lucide-react";
import { MockCompany } from "./mockCompanies";

interface MarketSearchProps {
  companies: MockCompany[];
  onSelectCompany: (company: MockCompany) => void;
}

export const MarketSearch = ({ companies, onSelectCompany }: MarketSearchProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const filteredCompanies = companies.filter(company => 
    company.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    company.symbol.toLowerCase().includes(searchTerm.toLowerCase()) ||
    company.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCompanySelect = (company: MockCompany) => {
    onSelectCompany(company);
    setIsOpen(false);
    console.log("Selected company:", company.symbol);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="w-full">
          <SearchIcon className="w-4 h-4 mr-2" />
          Search Market
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Search Companies</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <Input
            placeholder="Search by company name, symbol, or description..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full"
          />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {filteredCompanies.map((company) => (
              <Card
                key={company.id}
                className="cursor-pointer hover:bg-secondary/10 transition-colors"
                onClick={() => handleCompanySelect(company)}
              >
                <CardContent className="p-4">
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-2">
                      <BuildingIcon className="w-4 h-4" />
                      <span className="font-bold">{company.symbol}</span>
                    </div>
                    <Badge>{company.sector}</Badge>
                  </div>
                  <div className="text-sm">{company.name}</div>
                  <div className="text-xs text-muted-foreground mt-2 line-clamp-2">
                    {company.description}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};